import { reactive, watchEffect } from '@vue/composition-api';

import { actions } from '@/controller';
import store from '@/store';
import { prompt } from '@/components/Prompt';
import { snackbar } from '@/components/GlobalSnackbar';
import { useClient } from '@/use';
import { Menu, UserLevel } from '@/types';
import { filterMenus } from '@/filemenu/utils';
import { browseDatasetMenu, generateDatasetMenu, uploadVideoFileMenu, manageVideoFilesMenu } from './state';

const browseDataset: Menu = {
  text: 'Browse Datasets',
  click: () => { browseDatasetMenu.value = true; },
  disabled: false,
  disallowed: [UserLevel.User, UserLevel.Userhigh],
};
const closeDataset: Menu = {
  text: 'Close Current Dataset',
  click: async () => {
    const choice = await prompt.open({
      title: 'Close this dataset?',
      message: 'Are you sure you want to close this dataset? Any unsaved changes will be lost.',
      positiveText: 'Confirm',
      negativeText: 'Cancel',
    });

    if (choice) {
      actions.clearDataset();
    }
  },
  disabled: true,
  disallowed: [],
};
const generateDataset: Menu = {
  text: 'Generate Dataset',
  click: () => { generateDatasetMenu.value = true; },
  disabled: false,
  disallowed: [UserLevel.User, UserLevel.Userhigh],
};
let checkingUploadPolicy = false;
const uploadVideoFile: Menu = {
  text: 'Upload Video File',
  click: async () => {
    if (checkingUploadPolicy) return;
    checkingUploadPolicy = true;
    try {
      const policy = await useClient().getVideoUploadPolicy();
      if (policy.allowed) {
        uploadVideoFileMenu.value = true;
        return;
      }
      uploadVideoFileMenu.value = false;
      const proceed = await prompt.open({
        title: 'New video uploads are closed',
        message: policy.message,
        positiveText: 'Use Painface Nova',
        negativeText: 'Close',
      });
      if (proceed) window.location.assign(policy.replacement_url);
    } catch (error) {
      console.warn('Failed to check video upload availability', error);
      snackbar.dispatch({
        text: 'Unable to check upload availability. Please try again.',
        options: { color: 'error' },
      });
    } finally {
      checkingUploadPolicy = false;
    }
  },
  disabled: false,
  disallowed: [UserLevel.Annotator],
};
const manageVideoFiles = {
  text: 'Manage Video Files',
  click: () => { manageVideoFilesMenu.value = true; },
  disabled: false,
  disallowed: [UserLevel.Scorer, UserLevel.Annotator],
};

// Order will be preserved
const allMenus = [
  browseDataset,
  closeDataset,
  generateDataset,
  uploadVideoFile,
  manageVideoFiles,
];

export const menu = reactive({
  text: 'File',
  menu_width: 200,
  menu: [] as Menu[],
});

// Enable/disable menu items based on user level
watchEffect(() => {
  // Mark as enabled/disabled as necessary
  closeDataset.disabled = store.state.dataset.datasetId === null;

  // Filter allowed menus
  menu.menu = filterMenus(allMenus);
});
